import { render } from "./TheAdvantages.vue?vue&type=template&id=221623e4&scoped=true&lang=pug&bindings={\"title\":\"setup\",\"items\":\"setup\",\"lang\":\"setup\",\"titleItems\":\"setup\",\"btnText\":\"setup\",\"changeModalStatus\":\"setup\"}"
import script from "./TheAdvantages.vue?vue&type=script&lang=js"
export * from "./TheAdvantages.vue?vue&type=script&lang=js"

import "./TheAdvantages.vue?vue&type=style&index=0&id=221623e4&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-221623e4"

export default script